import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import PracticeAreas from "../components/PracticeAreas";
import Biography from "../components/Biography";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

const HomePage = () => {
  return (
    <div className="bg-white">
      <Navbar />
      <Hero />
      <PracticeAreas />
      <Biography />
      <Contact />
      <Footer />
    </div>
  );
};

export default HomePage;
